<template>
    <div class="auth d-flex bg-lightest">
        <component :is="file" v-if="file.length > 0"></component>

        <div class="main">
            <div class="d-flex justify-content-end align-items-center mt-5 mr-4">
                <div class="dark bold mr-3">{{ text }}</div>

                <router-link :to="{ name: path }" tag="div" class="btn outlined action wide">
                    {{ button }}
                </router-link>
            </div>

            <router-view></router-view>
        </div>
        <modal-wrapper></modal-wrapper>
    </div>
</template>

<script>
    import Login from '../auth/sidebars/LoginSidebar'
    import Signup from '../auth/sidebars/SignupSidebar'
    import Create from '../auth/sidebars/CreateSidebar'
    import ModalWrapper from '@/tools/modal/ModalWrapper.vue'

    export default {
        data: function() {
            return {
                file: '',
                link: 'signup',
                top: {
                    signup: { text: 'Don\'t have an account yet?', path: 'auth.signup', button: 'Get started' },
                    login: { text: 'Already have an account?', path: 'auth.login', button: 'Sign in' },
                }
            }
        },
        created: function() {
            this.eventHub.$on('sidebar', (filename) => this.file = filename);
            this.eventHub.$on('topLink', (link) => this.link = link);
        },
        beforeDestroy: function() {
            this.eventHub.$off('sidebar');
            this.eventHub.$off('topLink');
        },
        computed: {
            text: function() {
                return this.top[this.link].text;
            },
            path: function() {
                return this.top[this.link].path;
            },
            button: function() {
                return this.top[this.link].button;
            },
        },
        components: {
            Login,
            Signup,
            Create,
            ModalWrapper,
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .auth {
        h4 {
            color: $dark;
            margin-top: 0.75rem;
        }

        h5 {
            border-bottom: 0;
            text-transform: uppercase;
        }

        .back {
            color: $darker;
            text-decoration: underline;
        }

        .sidebar {
            max-width: 495px;
            background: #3a4956;

            &.alt {
                background: #595d66;
            }

            .text {
                position: absolute;
                bottom: 40%;
                text-align: center;

                .fs-small {
                    padding: 0 5rem;
                }

                .headline {
                    padding: 0 2rem;
                    margin: 3rem 0;
                }
            }
        }

        .main {
            overflow-y: auto;
            overflow-x: hidden;
            width: 100%;

            .buttons {
                height: 4vh;
            }

            .form-data {
                height: 80vh;

                > div {
                    min-width: 22rem;
                    width: 30vw;
                }
            }

            form {
                padding-bottom: 3rem;
            }
        }

        .signup-header {
            margin-top: 4rem;
            margin-bottom: 3rem;
            padding-bottom: 2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// Auth.vue?2ce119c4